export default __webpack_public_path__ + "static/media/img_step_lucia03-02.fc05207a.jpg";